module.exports = __webpack_public_path__ + "img/product-1.aada4984.png";